import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guard/auth.guard';

import { LoginComponent } from './components/login/login.component';

import { CambioPasswordComponent } from './components/cambio-password/cambio-password.component';
import { AuthChangePasswordGuard } from './_guard/auth-change-password.guard';

import { HomepageComponent } from './components/homepage/homepage.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { WaitingComponent } from './components/waiting/waiting.component';
import { ImpostazioniUtenteComponent } from './components/impostazioni-utente/impostazioni-utente.component';
import { AuthAmministratoreGuard } from './_guard/auth-amministratore.guard';
import { AuthRichiedenteGuard } from './_guard/auth-richiedente.guard';
import { AuthHomepageGuard } from './_guard/auth-homepage.guard';

export const produzione = 'app/components/produttore/produttore.module#ProduttoreModule';
export const spedizione = 'app/components/smistatore/smistatore.module#SmistatoreModule';
export const impostazioni = 'app/components/impostazioni/impostazioni.module#ImpostazioniModule';

const routes: Routes = [
  { path: '', component: HomepageComponent, canActivate: [AuthHomepageGuard], data: { componentName: 'homePage' } },

  { path: 'waiting', component: WaitingComponent },

  {
    path: 'produzione',
    loadChildren: produzione
  },

  {
    path: 'spedizione',
    loadChildren: spedizione
  },

  {
    path: 'impostazioni',
    loadChildren: impostazioni
  },

  /*
  { path: 'impostazioni', redirectTo: 'impostazioni/generali/_', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'impostazioni/:tabid', redirectTo: 'impostazioni/:tabid/_', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'impostazioni/:tabid/:accordionid', component: ImpostazioniComponent, canActivate: [AuthGuard] },
  { path: 'impostazioni/:tabid/:accordionid', component: ImpostazioniComponent, canActivate: [AuthGuard] },
  */

  { path: 'login', component: LoginComponent, data: { componentName: 'login' } },

  { path: 'impostazioniUtente', component: ImpostazioniUtenteComponent, canActivate: [AuthGuard] },
  { path: 'cambioPassword', component: CambioPasswordComponent, canActivate: [AuthChangePasswordGuard] },

  { path: '**', component: NotFoundComponent, data: { componentName: 'notFound' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts